// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class DistanceFromPointsInput {
  readonly origins: string[];
  readonly destinations: string[];

  constructor(data: { [key: string]: any } = {}) {
    this.origins = data.origins ?? [];
    this.destinations = data.destinations ?? [];
  }

  static zero(): DistanceFromPointsInput {
    const zeroValues: ExcludeMethodsDeep<DistanceFromPointsInput> = {
      origins: [],
      destinations: [],
    };
    return new DistanceFromPointsInput(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DistanceFromPointsInputWireFormat = {
  origins: string[];
  destinations: string[];
};

type NewDistanceFromPointsInputProps = PartialDeep<
  DistanceFromPointsInput,
  { recurseIntoArrays: true }
>;
export const NewDistanceFromPointsInput: (
  props: NewDistanceFromPointsInputProps,
) => DistanceFromPointsInput = (props) => new DistanceFromPointsInput(props);

type NewDistanceFromPointsInputFromWireFormatProps = PartialDeep<
  DistanceFromPointsInputWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDistanceFromPointsInputFromWireFormat: (
  props: NewDistanceFromPointsInputFromWireFormatProps,
) => DistanceFromPointsInput = (props) => new DistanceFromPointsInput(props);
